export const ensureDefaultAttribute = (el, attributeName, defaultValue) => {
    if (!el.getAttribute(attributeName)) {
        el.setAttribute(attributeName, defaultValue);
    }
};
